import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { PersonalizationService } from '../../services/personalization.service';
import { SessionStorageKeys } from '../../enum/session-storage-keys';
//import * as moment from 'moment';
import moment from 'moment';
import { RoutingService } from '../../services/routing.service';
import { getAppLang } from '../../helpers/utils';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from '../../services/lang.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../../services/permissions.service';
import { FiltrosDocumentosService } from '../../services/filtros-documentos.service';
import { FiltrosSpecsheetsService } from '../../services/filtros-specsheets.service';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {
  titlepage: string = 'OLÉ QMS';
  subtitle: string = 'Quality Management System';
  docElement: any = HTMLElement;

  isFullScreen = false;
  searchText = '';
  showSearchResult = false;
  userName = 'Braulio Romero';
  openSearch = false;
  // authTimer: any;
  // refreshing = false;
  user:any;

  currentLng = '';
  currentLngKey = getAppLang();

  public esAdmin: boolean = false;
  public permisos: any = {};

  constructor(
    private permissionsService: PermissionsService,
    private eRef: ElementRef,
    public authenticationService: SessionService,
    public personalizationService: PersonalizationService,
    private router: RoutingService,
    private routerSvc: Router,
    private lngSvc: LangService,
    public filtradoDocsService: FiltrosDocumentosService,
    public filtradoSpecsService: FiltrosSpecsheetsService
  ) {
    this.currentLng = lngSvc.languageLabel;
    // this.authTimer = setInterval(this.checkAuth.bind(this), 15 * 1000);
  }

  ngOnDestroy(): void {
    // if (this.authTimer) {
    //   clearInterval(this.authTimer);
    // }
  }

  ngOnInit(): void {
    this.docElement = document.documentElement;

    var tooltiptriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltiptriggerList.map(function (e) {
      return new bootstrap.Tooltip(e)
    });
    const userName = this.authenticationService.getUserName();
    if (userName) {
      this.userName = userName;
    }
    this.loadUserFromSession();
    this.personalizationService.renderUserImage();
    this.personalizationService.renderLogoImage();

    const authInfoString = sessionStorage.getItem(SessionStorageKeys.SESSION);
    // Se verifica que haya iniciado sesión
    if (authInfoString) {
      // Se obtienen los permisos en tiempo real
      setTimeout(() => {
        try {
          this.permissionsService.getPermissionsObservable().subscribe((permissions: any) => {
            let roles = permissions.find((item: any) => item.module === 'documents').roles;
            this.esAdmin = roles.every((rol: any) => (rol.toLowerCase().includes("admin"))); // Verificar si el usuario es Administrador
            this.permisos = permissions.find((item: any) => item.module === 'documents').actions; // Devuelve undefined si ningún elemento cumple la condición.
          });
        } catch (error) {
          console.log('cayó en error: ', error);
        }
      }, 3000);
    }
  }

  setLng(lng: string){
    if(this.lngSvc.language !== lng){
      this.lngSvc.language = lng;
      this.currentLngKey = lng;
      this.currentLng = this.lngSvc.languageLabel;
    }
  }

  /**
   * @description Función para cargar la info de perfil del usuario en sesión
   * @returns
   */
  private loadUserFromSession(): void {
    const authInfoString = sessionStorage.getItem(SessionStorageKeys.SESSION);
    if (!authInfoString) {
      this.router.goLogin();
      return;
    }
    try {
      const authInfo = JSON.parse(authInfoString);
      this.user = authInfo.user;
    } catch (error) {
      console.error('Error leyendo sesión:', error);
      this.router.goLogin();
    }
  }

  logout() {
    this.filtradoDocsService.limpiarFiltros();
    this.filtradoSpecsService.limpiarFiltros();
    this.authenticationService.logout();
  }

  ngAfterViewInit() {
    var chosensimple: any = $('.simplechosen')
    chosensimple.chosen()

    var thischosen: any = $('#searchfilterlist')
    thischosen.chosen({ no_results_text: "Oops, nothing found!", max_selected_options: null }).bind("chosen:maxselected", function () {
      thischosen.closest('.input-group').next('.invalid-feedback').show()
    });
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    const ignoreClickOnMeElement: any = document.getElementById('search-header');
    if(ignoreClickOnMeElement){
      const isClickInsideElement = ignoreClickOnMeElement.contains(event.target);
      if (!isClickInsideElement) {
        this.showSearchResult = false;
      }
    }

  }

  menuopen() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('menu-close');
  }

  rightbaropennotification() {
    const body: any = document.getElementsByTagName('body')[0];
    const notificationlist: any = document.getElementById('notificationwindow');

    if (body.classList.contains('rightbar-open') === true) {
      body.classList.remove('rightbar-open');
      notificationlist?.classList.add('d-none');
    } else {
      body.classList.add('rightbar-open');
      notificationlist?.classList.remove('d-none');
    }
  }

  dontclose(event: any) {
    event.stopPropagation();
  }

  searching() {
    if (this.searchText?.length > 0) {
      this.showSearchResult = true;
    } else {
      this.showSearchResult = false;
    }
  }

  irAsignacionDocs() {
    this.filtradoDocsService.limpiarFiltros();
    this.routerSvc.navigate(['/forms/sop/reasignacion-documentos']);
  }

  irRevisionAnual() {
    this.filtradoDocsService.limpiarFiltros();
    this.routerSvc.navigate(['/forms/sop/revision-anual']);
  }

}
